import React from 'react';

import Button from 'src/shared/components/common/button';
import { ModalCloseButton } from 'src/shared/components/common/modal';

type Props = {
  onDelete: (e: React.MouseEvent) => void
  onClose: (e: React.MouseEvent) => void
}

export const DeleteAccountModal = (props: Props) => {
  return (
    <div className="DeleteAccountModal">
      <ModalCloseButton />
      <div className="content">
        <h2 className="deleteModalHeader">Delete my account</h2>
        <div className="deleteAccountModalContent">
        Your contact information, order history, payment information, and any remaining Toast Cash will be deleted across all Toast restaurants. This cannot be undone.
        </div>
        <div className="modalButtonWrapper">
          <Button className="deleteAccountButton" onClick={props.onDelete}>Delete my account</Button>
          <br />
          <Button className="deleteAccountCancel" onClick={props.onClose}>Cancel</Button>
        </div>
      </div>
    </div>
  );
};
